import { GatsbyLinkProps } from 'gatsby';
import * as React from 'react';
import { LangLink } from './lang-link';

export const NavLink = ({ to, children, ...props }: GatsbyLinkProps<any>) => {
  return (
    <LangLink to={to} {...props}>
      {children}
    </LangLink>
  );
};
